import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../../store/gameStore';

const CountDown = observer(() => {
  const { reportResult, time, currentRound } = gameStore;

  useEffect(() => {
    if (!time) {
      setTimeout(() => {
        gameStore.setTime(null);
      }, 800);
    }
  }, [time]);
  return (
    <>
      {time || time === 0 ? (
        <div className='fs-countdown-block'>
          <span className='fs-countdown-num'>{time}</span>
          <div className='fs-countdown-progressbar'>
            <div
              className='fs-countdown-progressbar-stick'
              style={{
                width: reportResult.length
                  ? `${(time - 1) * (100 / (currentRound?.duration / 2 - 1))}%`
                  : `${(time - 1) * (100 / (currentRound?.duration - 1))}%`,
              }}
            />
          </div>
        </div>
      ) : null}
    </>
  );
});
export default CountDown;
